import React, { useEffect } from "react";
import { connect } from "react-redux";
import Header from "../../components/CommonComponents/Header";
import TagsHeader from "../../components/MapPageComponents/TagsHeader";
import MapContainer from "../../components/MapPageComponents/MapContainer";
import { getTagsAction } from "../../redux/actions/general";
import { getAllMarksForMapAction, getMarkPreviewAction } from "../../redux/actions/existingCoords";
import { addTempIdAction } from "../../redux/actions/coordinates";
import { getMapCharacteristicsAction } from "../../redux/actions/mapCharacteristics";
import { getMapAction } from "../../redux/actions/map";


const MapPage = ({
  getTagsAction,
  getAllMarksForMapAction,
  map,
  match,
  loader,
  getMapAction,
  addTempIdAction,
  getMapCharacteristicsAction,
  getMarkPreviewAction
}) => {

  useEffect(() => {
    getTagsAction();
    getMapAction(match.params.resortId)
  }, [])

  useEffect(() => {
    if (map && map.id && !match.params.previewId) {
      getAllMarksForMapAction(map.id);
      getMapCharacteristicsAction(map.id, 1, undefined, "new");
    }
  }, [map?.id]);

  useEffect(() => {
    if (match.params.previewId) {
      getMarkPreviewAction(match.params.previewId)
    }
  }, [])

  useEffect(() => {
    addTempIdAction();
  }, []);


  return (
    <>
      <Header />
      <TagsHeader />
      {loader ? <div className="loader"></div> : <MapContainer match = {match}/>}
    </>
  );
};

const mapStateToProps = state => {
  return {
    map: state.map.map,
    loader: state.coords.loading
  };
};
const mapDispatchToProps = {
  getMapAction,
  getTagsAction,
  getAllMarksForMapAction,
  addTempIdAction,
  getMapCharacteristicsAction,
  getMarkPreviewAction
};
export default connect(mapStateToProps, mapDispatchToProps)(MapPage);
